/**
 * ==============================================================================
 * 🌍 GLOBAL STANDART KOD (TÜM PROJELER İÇİN GEÇERLİDİR)
 * ==============================================================================
 *
 * Notification okuma uçlarının firma kapsamı sözleşmesi.
 * Her ürün, CompanyContext tarafından doğrulanmış aktif kapsamı aynen taşır.
 * Uygulama koduna göre kapsam üretilmez veya eksik kapsam `0` kabul edilmez.
 */

export interface ResolveNotificationCompanyScopeInput {
  selectedCompanyId: string | null | undefined;
}

export function isNotificationApiPath(apiPath: string): boolean {
  const normalized = String(apiPath || '').trim().toLowerCase();
  return normalized === '/api/notifications' || normalized.startsWith('/api/notifications/');
}

export function resolveNotificationCompanyScopeId(
  input: ResolveNotificationCompanyScopeInput,
): string | null {
  const selectedCompanyId = String(input.selectedCompanyId ?? '').trim();
  return selectedCompanyId || null;
}
